import { render } from "./saveimg.vue?vue&type=template&id=69647216"
import script from "./saveimg.vue?vue&type=script&lang=js"
export * from "./saveimg.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/staging-package-front-survey/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__